import { Auth0Provider } from '@auth0/auth0-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';

import Auth0ErrorHandler from './components/Auth/Auth0ErrorHandler';
import PrivateRoute from './components/Auth/PrivateRoute';
import ToastContainer from './components/ToastContainer';
import { ToastProvider } from './context/ToastContext';
import BookingRulesetPage from './pages/BookingRulesetPage/page';
import BulkOperationDetailsPage from './pages/BulkUploadPage/BulkOperationDetailsPage';
import BulkUploadPage from './pages/BulkUploadPage/page';
import ConversationPage from './pages/ConversationPage/page';
import MySettingsPage from './pages/MySettingsPage/page';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Auth0Provider
        domain={process.env.REACT_APP_AUTH0_DOMAIN || ''}
        clientId={process.env.REACT_APP_AUTH0_CLIENT_ID || ''}
        authorizationParams={{
          redirect_uri:
            window.location.origin +
            (process.env.REACT_APP_AUTH0_REDIRECT_PATH || '/app'),
          audience: process.env.REACT_APP_AUTH0_AUDIENCE || '',
        }}
      >
        <ToastProvider>
          <ToastContainer />
          <Router>
            <Auth0ErrorHandler>
              <Routes>
                <Route
                  path='/'
                  element={<Navigate to='/conversation' replace />}
                />
                <Route
                  path='/app'
                  element={
                    <PrivateRoute>
                      <Navigate to='/conversation' replace />
                    </PrivateRoute>
                  }
                />
                <Route
                  path='/conversation'
                  element={
                    <PrivateRoute>
                      <ConversationPage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path='/conversation/:chatId'
                  element={
                    <PrivateRoute>
                      <ConversationPage />
                    </PrivateRoute>
                  }
                />

                <Route
                  path='/bulk-upload'
                  element={
                    <PrivateRoute>
                      <BulkUploadPage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path='/bulk-upload/:bulkOperationId'
                  element={
                    <PrivateRoute>
                      <BulkOperationDetailsPage />
                    </PrivateRoute>
                  }
                />

                <Route
                  path='/booking-ruleset'
                  element={
                    <PrivateRoute>
                      <BookingRulesetPage />
                    </PrivateRoute>
                  }
                />

                <Route
                  path='/my-settings'
                  element={
                    <PrivateRoute>
                      <MySettingsPage />
                    </PrivateRoute>
                  }
                />
              </Routes>
            </Auth0ErrorHandler>
          </Router>
        </ToastProvider>
      </Auth0Provider>
      <ReactQueryDevtools initialIsOpen={false} buttonPosition='top-left' />
    </QueryClientProvider>
  );
}

export default App;
